import React from 'react';
import { withTranslation } from 'react-i18next';
export default withTranslation()(class ProgressPopup extends React.Component {

    preventClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
    }

    learnMoreLink = (e) => {
        window.open('https://support.myworkboard.com/en/articles/13516538-progress-colors-rag-on-objectives-and-key-results', '_blank');
    }

    render() {
        const { t } = this.props;
        return (
            <div className="progressDiv" onClick={(e) => this.preventClick(e)}>
                <div className="progressText">
                    {t('Progress percentage and color are based on the days left and the gap between the current value and the target.')}
                </div>
                <div className="learnMoreLink" onClick={(e) => this.learnMoreLink(e)}>{t('Learn More')}</div>                
            </div>
        )
    }
})